import { useLocation, useNavigate } from "react-router-dom";
import arrowLeft from '../../../assets/arrowLeft.svg'
import closeIcon from '../../../assets/closeIcon.svg'
import "./HeaderSiteCharge.css";
import logoDefault from '../../../assets/Logo_Spott_2.svg'
import  { ReactComponent as Loader }  from '../../../assets/Spinner.svg'
import { useBrandContext } from '../../../context/BrandContext';

interface Props {
  headerText?: string;
  showLogo?: boolean;
  showActionButtons?: boolean;
  backNavigation?: () => void;
  closeNavigation?: () => void;
  backgroundImageUrl?: undefined | string;
  logo?: undefined | string;
  bgColor?: undefined | string;
  isLoadingLogo?: boolean;
}

const HeaderSiteCharge: React.FC<Props> = ({headerText = '', isLoadingLogo = false, logo = undefined, bgColor = undefined, backgroundImageUrl = undefined, showLogo = true, showActionButtons= false, backNavigation, closeNavigation}) => {
  const navigate = useNavigate();
  //const location = useLocation();
  const brandContext = useBrandContext();
  //const routePaths = location.pathname.split('/');

  const backToHome = () => {
    navigate(`/${brandContext.brandName}/`);
  }

  return (
    <div style={{backgroundImage:`url(${backgroundImageUrl})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: 'transparent', backgroundBlendMode: 'unset'}} className="header-site-charge-basic-layout-main-container">
      <div className="header-site-charge-basic-layout-container">         
        {showLogo && !isLoadingLogo && <div onClick={backToHome} className="header-site-charge-basic-layout-image-container">
          <img loading="lazy" alt="logo-spott" height='50px' style={{backgroundColor: logo && bgColor ? bgColor : undefined}} src={logo ? logo : brandContext.appLogoFile ? brandContext.appLogoFile: logoDefault}/>
        </div>}   
        {isLoadingLogo && <Loader style={{backgroundColor: 'transparent !important', width: '60px', height: '50px', marginTop: '38px'}}/>}
        {headerText  && <div className="header-site-charge-basic-layout-text-section">
            <p>{headerText}</p>
        </div>}
        {showActionButtons && <div className="header-site-charge-action-content">
      <div onClick={() => navigate(-1)} className='arrow-left-icon-container'>
        <img className='style-arrow-left-icon' alt='arrow-left-icon' src={arrowLeft}/>
      </div>
      <img onClick={closeNavigation} alt='close-icon' src={closeIcon}/>
    </div>
        }
      </div>
    </div>
  );
};

export default HeaderSiteCharge;
